import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.YoutubeProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/youtube_profile']
  id: 'youtube-profile'
